"use client"; 

import InternalError from "@telesoft/ui/components/InternalError";
import Template from "@telesoft/ui/components/layout/template";

export default async function ErrorPage() {
  return (
    <Template variant="default">
      <InternalError />
    </Template>
  )
}